export var createConvertNumberToUnsignedLong = function createConvertNumberToUnsignedLong(unit32Array) {
  return function (value) {
    unit32Array[0] = value;
    return unit32Array[0];
  };
};